"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _404_1 = __importDefault(require("App/pages/404"));
var _500_1 = __importDefault(require("App/pages/500"));
var lockscreen_1 = __importDefault(require("App/pages/lockscreen"));
exports.default = [_404_1.default, _500_1.default, lockscreen_1.default];
//# sourceMappingURL=index.js.map